import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Customers from './pages/Customers';
import Employees from './pages/Employees';
import Invoices from './pages/Invoices';
import IncomingInvoices from './pages/IncomingInvoices';
import InvoiceNew from './pages/InvoiceNew';
import InvoiceView from './pages/InvoiceView';
import InvoiceEdit from './pages/InvoiceEdit';
import Users from './pages/Users';
import Settings from './pages/Settings';
import SmtpSettings from './pages/SmtpSettings';
import MailTemplates from './pages/MailTemplates';
import PermissionGroups from './pages/PermissionGroups';
import TaxCalculation from './pages/TaxCalculation';
import StandardDocuments from './pages/StandardDocuments';
import ApiDocumentation from './pages/ApiDocumentation';
import { useAuth } from './hooks/useAuth.jsx';
import './i18n';

function App() {
  const { user, loading } = useAuth();
  const { i18n } = useTranslation();

  // Set user's preferred language
  useEffect(() => {
    // Priority: Saved setting > User locale > Default
    const savedLocale = localStorage.getItem('locale');
    const targetLocale = savedLocale || user?.locale;
    
    if (targetLocale && targetLocale !== i18n.language) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user, i18n]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
      />
      <Route 
        path="/register" 
        element={user ? <Navigate to="/dashboard" replace /> : <Register />} 
      />
      <Route 
        path="/*" 
        element={
          user ? (
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/incoming-invoices" element={<IncomingInvoices />} />
                <Route path="/invoices/new" element={<InvoiceNew />} />
                <Route path="/invoices/:id" element={<InvoiceView />} />
                <Route path="/invoices/:id/edit" element={<InvoiceEdit />} />
                <Route path="/smtp-settings" element={<SmtpSettings />} />
                <Route path="/mail-templates" element={<MailTemplates />} />
                <Route path="/permission-groups" element={<PermissionGroups />} />
                <Route path="/users" element={<Users />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/tax-calculation" element={<TaxCalculation />} />
                <Route path="/standard-documents" element={<StandardDocuments />} />
                <Route path="/api-documentation" element={<ApiDocumentation />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        } 
      />
    </Routes>
  );
}

export default App;
